/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Heading1Inputs */

const zh_landing_pricing_heading1 = /** @type {(inputs: Landing_Pricing_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简单的定价，`)
};

const en_landing_pricing_heading1 = /** @type {(inputs: Landing_Pricing_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simple pricing that`)
};

const es_landing_pricing_heading1 = /** @type {(inputs: Landing_Pricing_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios simples que`)
};

/**
* | output |
* | --- |
* | "Simple pricing that" |
*
* @param {Landing_Pricing_Heading1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_heading1 = /** @type {((inputs?: Landing_Pricing_Heading1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Heading1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_pricing_heading1(inputs)
	if (locale === "en") return en_landing_pricing_heading1(inputs)
	return es_landing_pricing_heading1(inputs)
});